import { useMutation } from '@tanstack/react-query';
import { api } from '@/services/api';

export interface UploadedMedia {
  id: string;
  nombre: string;
  contentType: string;
  tamanoBytes: number;
  tipo: 'image' | 'pdf' | 'docx' | 'xlsx' | 'other';
  url: string;
}

export function useUploadFile(articleId?: string) {
  return useMutation({
    mutationFn: async (file: File): Promise<UploadedMedia> => {
      const fd = new FormData();
      fd.append('file', file);
      if (articleId) fd.append('articleId', articleId);
      const res = await api<{ media: UploadedMedia }>('/api/uploads', {
        method: 'POST',
        body: fd,
        isFormData: true,
      });
      return res.media;
    },
  });
}
